import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../services/global.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RefineryService } from '../../services/refinery.service';
import { adminService } from '../../services/admin.service';
import { Tenant } from '../../models/tenant.model';
import { Datasource } from '../../models/datasource.model';
import * as moment from 'moment';
import { AlertComponent } from '../../common/alert/alert.component';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-datasource-page',
  templateUrl: './datasource-page.component.html',
  styleUrls: ['./datasource-page.component.css']
})
export class DatasourcePageComponent implements OnInit {

  isLoading = false;
  loadPage2 = false;
  tenantList: Tenant[];
  dataSourceTypesList;

  public datasourceDetailForm = new UntypedFormGroup({
    datasourceId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    datasourceName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    datasourceTableName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    tenantName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    datasourceTypeName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    tenantId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
    datasourceConnStr: new UntypedFormControl({ value: '', disabled: false }),
    datasourceConnStrValue: new UntypedFormControl({ value: '', disabled: false }),
    datasourceOdbcConnStr: new UntypedFormControl({ value: '', disabled: false }),
    datasourceOdbcConnStrValue: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbKey: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbKeyValue: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbApiUrl: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbApiUrlValue: new UntypedFormControl({ value: '', disabled: false }),
    cosmosDbName: new UntypedFormControl({ value: '', disabled: false })
  });

  constructor(public dialogRef: MatDialogRef<DatasourcePageComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public globalService: GlobalService,
    private readonly adminService: adminService, private readonly refineryService: RefineryService) { }

  ngOnInit(): void {
    this.loadTenantList();
    this.loadDatasourcePage();
  }

  loadDatasourcePage() {
    this.isLoading = true;
    if (this.data.displayType === 'view' && this.globalService.isNotNullObject(this.data.data)) {
      this.datasourceDetailForm = new UntypedFormGroup({
        datasourceName: new UntypedFormControl({ value: this.data.data.datasourceName, disabled: true }, Validators.required),
        datasourceTableName: new UntypedFormControl({ value: this.data.data.datasourceTableName, disabled: true }, Validators.required),
        datasourceTypeName: new UntypedFormControl({ value: this.data.data.datasourceTypeName, disabled: true }, Validators.required),
        tenantId: new UntypedFormControl({ value: this.data.data.tenantId, disabled: true }, Validators.required),
        datasourceConnStr: new UntypedFormControl({ value: this.data.data.datasourceConnStr, disabled: true }),
        datasourceConnStrValue: new UntypedFormControl({ value: this.data.data.datasourceConnStrValue, disabled: true }),
        datasourceOdbcConnStr: new UntypedFormControl({ value: this.data.data.datasourceOdbcConnStr, disabled: true }),
        datasourceOdbcConnStrValue: new UntypedFormControl({ value: this.data.data.datasourceOdbcConnStrValue, disabled: true }),
        masterDataTable: new UntypedFormControl({ value: this.data.data.masterDataTable, disabled: true }, Validators.required),
        representation: new UntypedFormControl({ value: this.data.data.representation, disabled: true }, Validators.required),
        dataCharacteristic: new UntypedFormControl({ value: this.data.data.dataCharacteristic, disabled: true }, Validators.required),
        idCol: new UntypedFormControl({ value: this.data.data.idCol, disabled: true }, Validators.required),
        timeCol: new UntypedFormControl({ value: this.data.data.timeCol, disabled: true }, Validators.required),
        valueCol: new UntypedFormControl({ value: this.data.data.valueCol, disabled: true }, Validators.required),
        eventProcessedTimeCol: new UntypedFormControl({ value: this.data.data.eventProcessedTimeCol, disabled: true }, Validators.required),
        masterDataConnStr: new UntypedFormControl({ value: this.data.data.masterDataConnStr, disabled: true }, Validators.required),
        masterDataConnStrValue: new UntypedFormControl({ value: this.data.data.masterDataConnStrValue, disabled: true }, Validators.required),
        masterDataOdbcConnStr: new UntypedFormControl({ value: this.data.data.masterDataOdbcConnStr, disabled: true }, Validators.required),
        masterDataOdbcConnStrValue: new UntypedFormControl({ value: this.data.data.masterDataOdbcConnStrValue, disabled: true }, Validators.required),
        cosmosDbKey: new UntypedFormControl({ value: this.data.data.cosmosDbKey, disabled: true }),
        cosmosDbKeyValue: new UntypedFormControl({ value: this.data.data.cosmosDbKeyValue, disabled: true }),
        cosmosDbApiUrl: new UntypedFormControl({ value: this.data.data.cosmosDbApiUrl, disabled: true }),
        cosmosDbApiUrlValue: new UntypedFormControl({ value: this.data.data.cosmosDbApiUrlValue, disabled: true }),
        cosmosDbName: new UntypedFormControl({ value: this.data.data.cosmosDbName, disabled: true })
      });
    } else if (this.data.displayType === 'edit' && this.globalService.isNotNullObject(this.data.data)) {
      this.datasourceDetailForm = new UntypedFormGroup({
        datasourceName: new UntypedFormControl({ value: this.data.data.datasourceName, disabled: true }, Validators.required),
        datasourceTableName: new UntypedFormControl({ value: this.data.data.datasourceTableName, disabled: false }, Validators.required),
        datasourceTypeName: new UntypedFormControl({ value: this.data.data.datasourceTypeName, disabled: false }, Validators.required),
        tenantId: new UntypedFormControl({ value: this.data.data.tenantId, disabled: false }, Validators.required),
        datasourceConnStr: new UntypedFormControl({ value: this.data.data.datasourceConnStr, disabled: false }),
        datasourceConnStrValue: new UntypedFormControl({ value: this.data.data.datasourceConnStrValue, disabled: false }),
        datasourceOdbcConnStr: new UntypedFormControl({ value: this.data.data.datasourceOdbcConnStr, disabled: false }),
        datasourceOdbcConnStrValue: new UntypedFormControl({ value: this.data.data.datasourceOdbcConnStrValue, disabled: false }),
        masterDataTable: new UntypedFormControl({ value: this.data.data.masterDataTable, disabled: false }, Validators.required),
        representation: new UntypedFormControl({ value: this.data.data.representation, disabled: false }, Validators.required),
        dataCharacteristic: new UntypedFormControl({ value: this.data.data.dataCharacteristic, disabled: false }, Validators.required),
        idCol: new UntypedFormControl({ value: this.data.data.idCol, disabled: false }, Validators.required),
        timeCol: new UntypedFormControl({ value: this.data.data.timeCol, disabled: false }, Validators.required),
        valueCol: new UntypedFormControl({ value: this.data.data.valueCol, disabled: false }, Validators.required),
        eventProcessedTimeCol: new UntypedFormControl({ value: this.data.data.eventProcessedTimeCol, disabled: false }, Validators.required),
        masterDataConnStr: new UntypedFormControl({ value: this.data.data.masterDataConnStr, disabled: false }, Validators.required),
        masterDataConnStrValue: new UntypedFormControl({ value: this.data.data.masterDataConnStrValue, disabled: false }, Validators.required),
        masterDataOdbcConnStr: new UntypedFormControl({ value: this.data.data.masterDataOdbcConnStr, disabled: false }, Validators.required),
        masterDataOdbcConnStrValue: new UntypedFormControl({ value: this.data.data.masterDataOdbcConnStrValue, disabled: false },
          Validators.required),
        cosmosDbKey: new UntypedFormControl({ value: this.data.data.cosmosDbKey, disabled: false }),
        cosmosDbKeyValue: new UntypedFormControl({ value: this.data.data.cosmosDbKeyValue, disabled: false }),
        cosmosDbApiUrl: new UntypedFormControl({ value: this.data.data.cosmosDbApiUrl, disabled: false }),
        cosmosDbApiUrlValue: new UntypedFormControl({ value: this.data.data.cosmosDbApiUrlValue, disabled: false }),
        cosmosDbName: new UntypedFormControl({ value: this.data.data.cosmosDbName, disabled: false })
      });
    } else {
      this.datasourceDetailForm = new UntypedFormGroup({
        datasourceName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        datasourceTableName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        datasourceTypeName: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        tenantId: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        datasourceConnStr: new UntypedFormControl({ value: '', disabled: false }),
        datasourceConnStrValue: new UntypedFormControl({ value: '', disabled: false }),
        datasourceOdbcConnStr: new UntypedFormControl({ value: '', disabled: false }),
        datasourceOdbcConnStrValue: new UntypedFormControl({ value: '', disabled: false }),
        masterDataTable: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        representation: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        dataCharacteristic: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        idCol: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        timeCol: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        valueCol: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        eventProcessedTimeCol: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        masterDataConnStr: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        masterDataConnStrValue: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        masterDataOdbcConnStr: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        masterDataOdbcConnStrValue: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
        cosmosDbKey: new UntypedFormControl({ value: this.data.data.cosmosDbKey, disabled: false }),
        cosmosDbKeyValue: new UntypedFormControl({ value: this.data.data.cosmosDbKeyValue, disabled: false }),
        cosmosDbApiUrl: new UntypedFormControl({ value: this.data.data.cosmosDbApiUrl, disabled: false }),
        cosmosDbApiUrlValue: new UntypedFormControl({ value: this.data.data.cosmosDbApiUrlValue, disabled: false }),
        cosmosDbName: new UntypedFormControl({ value: this.data.data.cosmosDbName, disabled: false })
      });
    }
    this.isLoading = false;
  }

  /**Load Tenant List data for selected refinery*/
  loadTenantList() {
    this.adminService.getTenantList(this.refineryService.currentRefinery.refineryId).pipe(
      switchMap((data: any) => {
        this.tenantList = data;
        this.isLoading = false;
        return of(data);
      }),
      switchMap((data) => { return of(this.getDataSourceTypes()) }),
    ).subscribe();
  }

  /**Get list of datasource types*/
  getDataSourceTypes() {
    this.adminService.getDataSourceTypesList().subscribe((data: any): void => {
      this.dataSourceTypesList = data;
      this.isLoading = false;
    }, (error: Error) => {
      console.log('Error while fetching data source types list', error.message);
    });
  }

  /**Cancels the pop-up */
  onCancelClick(value: boolean): void {
    this.dialogRef.close(value);
  }

  changePage(pageStatus: boolean) {
    this.loadPage2 = pageStatus;
  }

  disableSave() {
    const datasourceTypeName = this.datasourceDetailForm.get('datasourceTypeName').value;

    if (datasourceTypeName == 'SQL Server') {

      this.datasourceDetailForm.get('cosmosDbKey').clearValidators();
      this.datasourceDetailForm.get('cosmosDbKeyValue').clearValidators();
      this.datasourceDetailForm.get('cosmosDbApiUrl').clearValidators();
      this.datasourceDetailForm.get('cosmosDbApiUrlValue').clearValidators();
      this.datasourceDetailForm.get('cosmosDbName').clearValidators();
      this.datasourceDetailForm.get('datasourceConnStr').setValidators([Validators.required]);
      this.datasourceDetailForm.get('datasourceConnStrValue').setValidators([Validators.required]);
      this.datasourceDetailForm.get('datasourceOdbcConnStr').setValidators([Validators.required]);
      this.datasourceDetailForm.get('datasourceOdbcConnStrValue').setValidators([Validators.required]);
    }
    else if (datasourceTypeName == 'Cosmos DB') {
      this.datasourceDetailForm.get('datasourceConnStr').clearValidators();
      this.datasourceDetailForm.get('datasourceConnStrValue').clearValidators();
      this.datasourceDetailForm.get('datasourceOdbcConnStr').clearValidators();
      this.datasourceDetailForm.get('datasourceOdbcConnStrValue').clearValidators();
      this.datasourceDetailForm.get('cosmosDbKey').setValidators([Validators.required]);
      this.datasourceDetailForm.get('cosmosDbKeyValue').setValidators([Validators.required]);
      this.datasourceDetailForm.get('cosmosDbApiUrl').setValidators([Validators.required]);
      this.datasourceDetailForm.get('cosmosDbApiUrlValue').setValidators([Validators.required]);
      this.datasourceDetailForm.get('cosmosDbName').setValidators([Validators.required]);
    }

    const check: boolean = !this.datasourceDetailForm.valid;
    return check;
  }

  saveDatasource() {
    const datasourceModel: Datasource = this.datasourceDetailForm.value;
    datasourceModel.datasourceName = this.datasourceDetailForm.controls.datasourceName.value;
    if (datasourceModel.datasourceName.includes("_")) {
      this.isLoading = false;
      this.globalService.showAlert(AlertComponent, { success: false, message: "Datasource Name cannot contain underscore ('_') in it." });
    } else {
      datasourceModel.datasourceTypeId = this.dataSourceTypesList.find((item: any) =>
        item.datasourceTypeName === datasourceModel.datasourceTypeName).datasourceTypeId;
      datasourceModel.datasourceId = this.data.data.datasourceId ? this.data.data.datasourceId : 0;
      if (this.data.displayType === 'add') {
        datasourceModel.datasourceId = 0;
        datasourceModel.createdBy = this.globalService.loggedInUser;
        datasourceModel.createdTime = moment.utc(new Date()).local().format('YYYY-MM-DDTHH:mm:ss');
      }
      datasourceModel.lastModifiedBy = this.globalService.loggedInUser;
      datasourceModel.lastModifiedTime = moment.utc(new Date()).local().format('YYYY-MM-DDTHH:mm:ss');
      this.adminService.saveDatasource(datasourceModel, this.data.displayType).subscribe((data: any): void => {
        this.globalService.showAlert(AlertComponent, { success: true, message: 'Datasource ' + datasourceModel.datasourceName + ' saved successfully.' });
        this.onCancelClick(true);
      }, (error: Error) => {
        this.isLoading = false;
        this.globalService.showAlert(AlertComponent, { success: false, message: 'Datasource ' + datasourceModel.datasourceName + ' could not be saved.' });
      });
    }
  }

}
